import React, { useContext } from 'react'
import { Table } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { GET_ALL_DIGIO_AUTO_DEBIT_SCHEDULE_REQUESTS } from './graphql/Queries'
import Loader from 'components/loaders/Loader'
import Page404 from 'components/Page404'
import moment from 'moment'
import { AppContext } from 'AppContext'

const DigioAutoRequest = ({ id }) => {
  const { data, loading, error } = useQuery(
    GET_ALL_DIGIO_AUTO_DEBIT_SCHEDULE_REQUESTS,
    { variables: { where: { userId: id } } }
  )
  const {
    state: { isMobile },
  } = useContext(AppContext)

  if (loading) return <Loader />
  if (error) return <Page404 />

  const columns = [
    {
      title: 'Request Id',
      dataIndex: 'requestId',
      render: (text, record) =>
        record?.res?.id ? record?.res?.id : record?.res?.details,

      width: isMobile ? '120px' : 'auto',
    },
    {
      title: 'Client Name',
      dataIndex: 'clientName',
      render: (text, record) => record?.req?.customer_name,

      width: isMobile ? '120px' : 'auto',
    },
    {
      title: 'UMRN Number',
      dataIndex: 'umrnNumber',
      render: (text, record) => record?.req?.umrn || '-',
      width: isMobile ? '120px' : 'auto',
    },
    {
      title: 'Schedule Date',
      dataIndex: 'scheduleDate',
      render: (text, record) =>
        record?.req?.settlement_date
          ? moment(record?.req?.settlement_date).format('DD-MMM-YYYY')
          : '-',
      width: isMobile ? '120px' : 'auto',
    },
    {
      title: 'Settlement Amount',
      dataIndex: 'settlementAmount',
      render: (text, record) =>
        record?.req?.amount ? record?.req?.amount : '-',
      width: isMobile ? '120px' : 'auto',
    },
    {
      title: 'Request Status',
      dataIndex: 'status',
      render: (text, record) =>
        record?.res?.id ? record?.res?.status : record?.res?.code,
      width: isMobile ? '120px' : 'auto',
    },
  ]
  return (
    <>
      <Table
        dataSource={
          data?.getDigioAutoScheduleRequestData
            ? data?.getDigioAutoScheduleRequestData
            : []
        }
        loading={loading}
        columns={columns}
      />
    </>
  )
}
export default DigioAutoRequest
